import { Dialog, Drawer, Pagination } from 'element-ui'

const DialogPathed = {
  extends: Dialog,
  data () {
    return {
      wrapperMouseDowned: false
    }
  },
  mounted () {
    this.$el.onmousedown = e => {
      this.wrapperMouseDowned = e.target.classList.contains('el-dialog__wrapper')
    }
  },
  methods: {
    handleWrapperClick () {
      if (!this.closeOnClickModal || !this.wrapperMouseDowned) return;
      this.handleClose();
    }
  }
}

const DrawerPathed = {
  extends: Drawer,
  data () {
    return {
      wrapperMouseDowned: false
    }
  },
  mounted () {
    this.$el.onmousedown = e => {
      this.wrapperMouseDowned = e.target.classList.contains('el-drawer__container')
    }
  },
  methods: {
    handleWrapperClick () {
      if (this.wrapperClosable && this.wrapperMouseDowned) {
        this.closeDrawer();
      }
    }
  }
}

const PaginationPathed = {
  extends: Pagination,
  props: {
    pagerCount: {
      type: Number,
      validator (value) {
        return (value | 0) === value && value > 1 && value < 22;
      },
      default: 7
    }
  }
}

export default {
  install (Vue) {
    Vue.component(Dialog.name, DialogPathed)
    Vue.component(Drawer.name, DrawerPathed)
    Vue.component(Pagination.name, PaginationPathed)
  }
}